import React from 'react';
import StarIcon from '@mui/icons-material/Star';

const FavoriteButton = (props: { onClick: () => void; isFavorite: boolean }) => (
  <StarIcon sx={{ color: props.isFavorite ? '#E9D189' : '#DDDDDD', cursor: 'pointer' }} onClick={props.onClick} />
);

export default FavoriteButton;
